export default __webpack_public_path__ + "static/media/Mary_Clavieres_AHV_In_Moms_We_Trust.4bc723d5.jpg";